<template>
  <div class="auth-form">
    <div class="container">
      <div class="row login-form mx-4 mx-sm-0">
        <div class="col-md-4 login-icon my-4 my-sm-0">
          <img :src="require(`../../img/login-icon.png`)" />
        </div>
        <div class="col-md-8 login-form-content mx-4 mx-sm-0">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <slot name="header"></slot>
          </div>
          <slot></slot>
        </div>
        <div class="col-md-12 login-form-footer">
          <div class="d-flex justify-content-center create-account row">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOptions } from 'config';

export default {
  name: 'AuthForm',
  beforeCreate() {
    this.$store.dispatch('auth/clearErrors');
  },
  data() {
    return {
      loginOptions,
    };
  },
};
</script>
<style lang="less">
@import '~bootstrap-less-port/less/bootstrap-grid';
@grid-gutter-width: 0px;

.auth-form {
  .row;
  padding: 0px;
  background-color: @auth-page-background;
  min-height: 100vh;
}
.login-form {
  background-color: @login-form-background;
  margin-top: 40px;

  h2 {
    margin-top: 20px;
    padding: 0 0 0 0px;
    .RegularFont(20px);
    font-weight: 300;
  }

  .login-icon {
    position: relative;
    height: 100%;
    text-align: center;
  }
}

.via-social-media {
  margin: 30px 0;
}
.via-social-media a {
  padding-left: 44px;
  background-position: left;
  background-repeat: no-repeat;
  line-height: 32px;
  color: @login-form-social-media-color;
  display: inline-block;
}
.via-social-media a.via-fb {
  background-image: url(../../img/icon-via-fb.png);
}
.via-social-media a.via-tw {
  background-image: url(../../img/icon-via-tw.png);
}
.via-social-media a.via-go {
  background-image: url(../../img/icon-via-go.png);
}
.login-form-content {
  form {
    padding-bottom: 20px;
    & > div {
      margin: 10px 0;
    }
  }

  input[type='text'],
  input[type='password'] {
    background-color: @login-form-input-background;
    border: none;
    line-height: 34px;
    padding: 0 10px;
  }

  a.forgot-password {
    color: @login-form-forgot-password-color;
    line-height: 34px;
  }

  div.submit {
    margin: 20px 0 30px 0;
  }

  input[type='submit'] {
    background-color: @login-form-submit-background;
    color: @login-form-submit-color;
    height: 32px;
    border-radius: 16px;
    border: none;
    padding: 0 20px;
    cursor: pointer;
  }

  label {
    .RegularFont(12px);
    cursor: pointer;
  }
}

.login-form-footer {
  background-color: @login-form-footer-background;
}
.create-account {
  h2 {
    padding: 0 0 0 10px;
    .RegularFont(20px);
    font-weight: 300;
    line-height: 32px;
    margin: 10px 0;
  }

  a.create-account-link {
    background-color: @login-form-footer-link-background;
    color: @login-form-footer-link-color;
    height: 32px;
    border-radius: 16px;
    border: none;
    padding: 0 20px;
    display: inline-block;
    .BoldFont(16px);
    margin: 10px 0;
    line-height: 32px;
  }
}

.error-messages {
  .error {
    font-size: 16px;
    font-weight: bold;
  }
}

.private-message {
  font-size: 16px;
  font-weight: bold;
}

.request-access {
  .error-messages {
    list-style: none;
    padding-left: 0px;
  }
}

@media (min-width: 992px) {
  .login-form .login-icon {
    padding-top: 70px;
    padding-bottom: 40px;
  }
}
</style>
